import { FundsVersionsService_fundVersionsServiceGetEntity } from '@festina/unitlink-general-types/unitlink/hooks/FundsVersionsService_fundVersionsServiceGetEntity'

export const useLazyFetchFundVersion =
  FundsVersionsService_fundVersionsServiceGetEntity.useLazyQuery
